<!-- 成绩公示 -->
<template>
    <div  class="score-table">
        <div class="title">
            第{{round}}轮 成绩公示表({{ second }}秒)
            <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
        </div>
        <div class="flex-row-1" v-if="isShow">
            <el-table class="custom-table custom-table2"
                :data="firstTableData"
                :cell-class-name="tableCellClassName"
                :row-class-name="tableRowClassName"
                 border>
                <el-table-column                    
                    label="东西"   
                    align="center"           
                >
                <template slot-scope="scope" >
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>/<span :class="scope.row.statusE === '弃权'? 'gray-row':''">{{ scope.row.usernameE }}</span>
                    </div>
                    <div  v-else>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                    prop="scoreWE"
                    label="级数"
                    width="80px"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="80px"
                    align="center"                      
                    >
                </el-table-column>
                <el-table-column
                    prop="scoreSN"
                    label="级数"
                    width="80px"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column                    
                    label="南北"
                    align="center"                     
                >
                <template slot-scope="scope">
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>/<span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table> 
            <el-table class="custom-table custom-table2"
                v-if="secondTableData.length > 0"
                :data="secondTableData"
                :cell-class-name="tableCellClassName"
                :row-class-name="tableRowClassName"
                style="margin-left: 15px;"
                 border>
                <el-table-column                    
                    label="东西"   
                    align="center"           
                >
                <template slot-scope="scope" >
                    <div v-if="pubType === '1'">
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>/<span :class="scope.row.statusE === '弃权'? 'gray-row':''">{{ scope.row.usernameE }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                    </div>                   
                </template>
                </el-table-column>
                <el-table-column
                    prop="scoreWE"
                    label="级数"
                    width="80"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="80"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="scoreSN"
                    label="级数"
                    width="80"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column                   
                    label="南北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div v-if="pubType === '1'">
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''">{{ scope.row.usernameS }}</span>/<span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table> 
        </div>      
    </div>
 </template> 
 <script>
 import Qrcode from '@/components/Qrcode'
import { mapState } from 'vuex'
 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     components:{
        Qrcode,
     },
     data() {
         return {
            isShow: false,
            tableData: [],
            firstTableData: [],
            secondTableData: [],
            second: 5,
            timer: null,
            loading: false
         }
     },
     created() {
 
     },
     mounted() {
        
     },
     computed:{
        ...mapState(['round'])
    },
     methods: {
        tableCellClassName({row,column, rowIndex}){
            // console.log(row,column)
            // 成绩这一列一种颜色
            // if(column.property === 'usernameW' && row.statusW === '弃权'){
            //     return 'gray-row'
            // }
            // if(column.property === 'usernameS' && row.statusS === '弃权'){
            //      return 'gray-row'
            // }
            if(column.property === 'deskNo' && row.games === 111){
                return 'green-row'
            }
        },
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'light-green-row'
            }
        },
         // 分数查询
         initData(){
            let params = {
                opcode: this.$code.ScoreNotice,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 0,
                i_desk_no: 0
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    if(result.length > 0) {  
                        this.isShow = true                      
                        let newArr   = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                         return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: username,
                            phone: item['选手手机号'],
                            company: item['协会（俱乐部）'],
                            userId: item['选手账号'],
                            seat: item['座位'],
                            round: item['第几轮'],
                            score: item['成绩'],
                            partner: item['搭档名称'],
                            games: item['局数'],
                            status: item['状态']
                         }
                     })
                    this.tableData = this.selectDeskNoNew(newArr)
                    // console.log(this.tableData)
                    let  playerArr  = JSON.parse(JSON.stringify(this.tableData))
                        if(playerArr.length > 10){
                            const splitSize = Math.round(playerArr.length / 2); 
                            this.firstTableData = playerArr.slice(0, splitSize);  
                            this.secondTableData = playerArr.slice(splitSize);  
                        }else{
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }
                    }else{
                        this.isShow = true
                        this.tableData = []
                        this.firstTableData= []
                        this.secondTableData = []
                        this.$message.error('请到编排界面，点击编排按钮！')
                        this.stopCountdown()                        
                    }                   
                 }
             }).catch(err=>{
                this.stopCountdown()
             })
         },
        //  这个方法暂时不用
         selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                           
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username                            
                        }                       
                        result.push({
                            deskNo: item.deskNo,
                            scoreWE: (newArr.filter(i =>  i.seat.includes('东')))[0].score,
                            scoreSN: (newArr.filter(i =>  i.seat.includes('北')))[0].score,
                            games: item.games,
                            statusWE:(newArr.filter(i =>  i.seat.includes('东')))[0].status,
                            statusSN:(newArr.filter(i =>  i.seat.includes('北')))[0].status,                           
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                        })
                 }
             });
             return result
        }, 
        // 桌号和分数
        selectDeskNoNew(arr){
            let result = []
            arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameW = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                        let usernameE = (newArr.filter(i =>  i.seat.includes('西')))[0].username
                        let usernameS = (newArr.filter(i =>  i.seat.includes('南')))[0].username
                        let usernameN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        let scoreW = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                        let scoreE = (newArr.filter(i =>  i.seat.includes('西')))[0].score
                        let scoreS = (newArr.filter(i =>  i.seat.includes('南')))[0].score
                        let scoreN = (newArr.filter(i =>  i.seat.includes('北')))[0].score    
                        let scoreWE = ''
                        let scoreSN= ''
                        let statusWE = ''
                        let statusSN = ''
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            if(scoreW === '弃' && scoreE === '弃')  {
                                scoreWE = scoreW
                            }else if(scoreW === '弃' && scoreE !== '弃'){
                                scoreWE = scoreE
                            }else if(scoreW !== '弃' && scoreE === '弃'){
                                scoreWE =  scoreW
                            }else if(scoreW !== '弃' && scoreE !== '弃'){
                                scoreWE = scoreW
                            } 
                            if(scoreS === '弃' && scoreN === '弃')  {
                                scoreSN = scoreS
                            }else if(scoreS === '弃' && scoreN !== '弃'){
                                scoreSN = scoreN
                            }else if(scoreS !== '弃' && scoreN === '弃'){
                                scoreSN =  scoreS
                            }else if(scoreS !== '弃' && scoreN !== '弃'){
                                scoreSN = scoreS
                            } 
                        }else{
                            scoreWE =(newArr.filter(i =>  i.seat.includes('东')))[0].score
                            scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].score

                            statusWE = (newArr.filter(i =>  i.seat.includes('东')))[0].status
                            statusSN =(newArr.filter(i =>  i.seat.includes('北')))[0].status  

                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username      
                        }                       
                        result.push({
                            deskNo: item.deskNo,                            
                            usernameW: usernameW,
                            usernameE: usernameE,
                            usernameS: usernameS,
                            usernameN: usernameN,
                            scoreWE: scoreWE,
                            scoreSN: scoreSN,                              
                            games: item.games,                        
                            statusW: (newArr.filter(i =>  i.seat.includes('东')))[0].status,
                            statusE: (newArr.filter(i =>  i.seat.includes('西')))[0].status,
                            statusS: (newArr.filter(i =>  i.seat.includes('南')))[0].status,
                            statusN: (newArr.filter(i =>  i.seat.includes('北')))[0].status,
                            statusWE: statusWE,
                            statusSN: statusSN,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                        })
                 }
             });
             return result
        }, 
        stopCountdown(){
            clearInterval(this.timer)
            this.timer = null
        },
        countDown(){            
            this.timer = setInterval(()=>{
                if(this.second >0){
                    this.second--
                }else{
                    this.second = 5
                    this.initData()
                }
            },1000)
        },
        toggleFullScreen(){
            const routeUrl = this.$router.resolve({ name: 'fullScoreRefresh', 
            query: { id: this.pubId,}});
            window.open(routeUrl.href, '_blank');   
            
        }, 
     },
     beforeDestroy() {
        this.stopCountdown()  
     },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
     margin-bottom: 10px;
 }
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.el-table >>> .light-green-row{
    background-color: #bbffbb
  }
.el-table >>> .green-row{
    background-color: green;
    color:#fff
  }
.el-table >>> .gray-row{
    background-color: #b9b5b5;
}
.el-table >>> .white-row{
    background-color: #f0f9eb;
  } 
 </style>


// WEBPACK FOOTER //
// src/views/setting/components/scoreRefresh.vue